import axios from "axios";
import { toast } from "react-toastify";
import { APIURL } from "../utils/misc";
import api from "src/utils/api";
import { HOME_TYPE, HOTEL_TYPES } from "./types";

export function setHomes(homes) {
  return {
    type: HOME_TYPE.SET_HOME,
    homes,
  };
}

export function fetchHomes() {
  return async (dispatch) => {
    try {
      const res = await api.get(`homes/host/`);
      dispatch(setHomes(res.data.data));
    } catch (error) {
      dispatch({
        type: HOME_TYPE.HOME_ERROR,
        payload: error.message,
      });
    }
  };
}

export const addHome = (data, navigate) => async (dispatch) => {
  let res;
  try {
    res = await api.post(`homes/host/`, data);
    dispatch({
      type: HOME_TYPE.ADD_HOME,
      payload: res.data.data,
    });
    navigate("/app/home/addHomeImage", { replace: true });
  } catch (error) {
    if (error.message === "Network Error") {
      dispatch({
        type: HOME_TYPE.HOME_ERROR,
        payload: "Please check your network connection.",
      });
    } else {
      dispatch({
        type: HOME_TYPE.HOME_ERROR,
        payload: "We are working on it, please try again while we implement",
      });
    }
  }
};

export const getHomeById = (data, navigate) => {
  return async (dispatch) => {
    try {
      const res = await api.get(`homes/${data}`);
      dispatch({
        type: HOME_TYPE.GET_HOME,
        payload: res.data.data,
      });
      navigate && navigate("/app/home/edit");
    } catch (error) {
      toast.error(
        "We are working on it, please try again later when we implement it.",
      );
    }
  };
};

export const editHomeImages = (data, homeId, navigate) => async (dispatch) => {
  try {
    const res = await api.put(`homes/${homeId}/images`, data);
    dispatch({
      type: HOME_TYPE.EDIT_HOME,
      payload: res.data.data,
    });
    navigate("/app/homes", { replace: true });
  } catch (error) {
    toast.error(
      "We are working on it, please try again later when we implement it.",
    );
  }
};

export const updateHomeDetails =
  (data, homeId, navigate) => async (dispatch) => {
    try {
      const res = await api.patch(`homes/host/home/${homeId}`, data);
      dispatch({
        type: HOME_TYPE.EDIT_HOME,
        payload: res.data.data,
      });
      navigate("/app/homes", { replace: true });
    } catch (error) {
      toast.error(
        "We are working on it, please try again later when we implement it.",
      );
    }
  };

export const uploadHomeCoverImage = (data) => async () => {
  try {
    const res = await api.post(`homes/mult_file_upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data[0].image_url;
  } catch (error) {
    toast.error("File upload failed!");
  }
};

export const deleteHomeImageFile = (data) => async () => {
  try {
    const res = await api.post(`homes/deleteImage`, data);
    return res.data;
  } catch (error) {
    toast.error("Action  failed!");
  }
};

// HOTEL ACTIONS

const hotelPropertyAddedSuccess = (data) => {
  return {
    type: HOTEL_TYPES.ADD_HOTEL_SUCCESS,
    payload: data,
  };
};

export const asyncAddHotelProperty = (data) => async (dispatch) => {
  try {
    const res = await api.post(`hotels/host/`, data);
    dispatch(hotelPropertyAddedSuccess(res.data.data));
  } catch (error) {
    toast.error("Error adding hotel property, please try again");
  }
};

export const asyncAddHotelRooms =
  (data, property, isEdit = false, tab = "images") =>
  async (dispatch) => {
    try {
      const roomRes = await api.post(`hotels/rooms/`, data);
      if (roomRes.data.status === "success") {
        const res = await api.patch(`hotels/host/hotel/${property.id}`, {
          ...property,
          rooms: [...property.rooms, roomRes.data.data],
        });
        dispatch({
          type: HOTEL_TYPES.ADD_HOTEL_ROOM_SUCCESS,
          payload: { ...res.data.data, tab: tab },
        });
      }
      if (isEdit) window.location.replace("/app/properties");
      // toast.success("Hotel rooms added successfully");
    } catch (error) {
      toast.error("Error adding hotel rooms, please try again");
    }
  };

export const toggleToRoomsTab = () => async (dispatch) => {
  try {
    dispatch({
      type: HOTEL_TYPES.TOGGLE_ROOM_TAB,
      payload: "rooms",
    });
  } catch (error) {
    toast.error("Error toggling to rooms tab, please try again");
  }
};

export const toggleTab = (payload) => (dispatch) => {
  dispatch({
    type: HOTEL_TYPES.TOGGLE_TAB,
    payload,
  });
};

const propertyImagesAddedSuccess = (data) => {
  return {
    type: HOTEL_TYPES.PROPERTY_IMAGES_ADDED_SUCCESS,
    payload: data,
  };
};

export const asyncAddPropertyImages = (data, navigate) => async (dispatch) => {
  try {
    const res = await api.put(`hotels/${data.id}/images`, data);
    dispatch(propertyImagesAddedSuccess(res.data.data));
    toast.success("Hotel property images added successfully");
    setTimeout(() => {
      navigate("/app/properties", { replace: true });
    }, 2000);
  } catch (error) {
    toast.error("Error adding hotel property images, please try again");
  }
};

const propertiesFetchSuccess = (payload) => ({
  type: HOTEL_TYPES.PROPERTIES_FETCH_SUCCESS,
  payload,
});

export const fetchPropertiesAsync = () => async (dispatch) => {
  try {
    const res = await api.get(`hotels/host/`);
    dispatch(propertiesFetchSuccess(res.data.data));
  } catch (error) {
    toast.error("Error fetching properties, please try again");
  }
};

export const fetchPropertyById = (propertyId, navigate) => async (dispatch) => {
  try {
    const res = await api.get(`hotels/${propertyId}`);
    dispatch({
      type: HOTEL_TYPES.GET_HOTEL,
      payload: res.data.data,
    });
    navigate("/app/hotel/edit");
  } catch (error) {
    toast.error("Error fetching property, please try again");
  }
};

export const updateHotelDetails = (data) => async (dispatch) => {
  try {
    const res = await api.patch(`hotels/host/`, data);
    dispatch({
      type: HOTEL_TYPES.EDIT_HOTEL,
      payload: res.data.data,
    });
    toast.success("Hotel details updated successfully");
  } catch (error) {
    toast.error("Error updating hotel details, please try again");
  }
};

export const updateRoomDetails = (data, propertyId) => async (dispatch) => {
  try {
    await api.patch(`hotels/rooms/`, data);
    const res = await api.get(`hotels/${propertyId}`);
    dispatch({
      type: HOTEL_TYPES.GET_HOTEL,
      payload: res.data.data,
    });
    toast.success("Room details updated successfully");
  } catch (error) {
    toast.error("Error updating room details, please try again");
  }
};
